import {
  getLeoUuid,
  LeoUUID,
  getString,
} from "@surya-digital/leo-ts-types";

export interface APIKeyDTO {
  apiKeyId: string;
  apiSecretKey: string;
}

export class APIKey {
  readonly isAPIKeyAPIKey: boolean = true;

  readonly apiKeyId: LeoUUID;
  readonly apiSecretKey: string;


  constructor(
  apiKeyId: LeoUUID, 
  apiSecretKey: string
  ) {
    this.apiKeyId = apiKeyId;
    APIKey.validateApiSecretKey(apiSecretKey);
    this.apiSecretKey = apiSecretKey;
  }

  static fromDTO(dto: APIKeyDTO): APIKey {
    const apiKeyId = getLeoUuid(dto, "apiKeyId", InvalidAPIKeyApiKeyIdError);
    const apiSecretKey = getString(dto, "apiSecretKey", InvalidAPIKeyApiSecretKeyError);
    return new APIKey(
      apiKeyId,
      apiSecretKey
    );
  }

  toDTO(): APIKeyDTO {
    const dto: APIKeyDTO = {
        apiKeyId: this.apiKeyId.toDTO(),
        apiSecretKey: this.apiSecretKey
    };
    return dto;
  }
  private static validateApiSecretKey = (apiSecretKey: string): void => {
    if(apiSecretKey.trim().length === 0) {
      throw new InvalidAPIKeyApiSecretKeyNonEmptyError(
        `Attribute apiSecretKey cannot be an empty string.`
      );
    }
  }
  
}

APIKey.prototype.toString = function toString(): string {
  return `APIKey(apiKeyId='${this.apiKeyId}',apiSecretKey='${this.apiSecretKey}')`;
};

export class InvalidAPIKeyError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidAPIKeyError";
  }
}
export class InvalidAPIKeyApiKeyIdError extends InvalidAPIKeyError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidAPIKeyApiKeyIdError";
  }
}

export class InvalidAPIKeyApiSecretKeyError extends InvalidAPIKeyError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidAPIKeyApiSecretKeyError";
  }
}

export class InvalidAPIKeyApiSecretKeyNonEmptyError extends InvalidAPIKeyApiSecretKeyError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidAPIKeyApiSecretKeyNonEmptyError";
  }
}
